import React from 'react';
import { Box, Typography, Container, Grid, Link, Stack, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  WHATSAPP_URL,
  WHATSAPP_DISPLAY,
  CONTACT_EMAIL,
  COMPANY_LOCATION,
  BRAND_NAME,
} from '../constants/site';
import { brandColors } from '../theme';

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: { xs: 5, md: 6 },
      bgcolor: '#060D18',
      color: 'rgba(255,255,255,0.75)',
      overflow: 'hidden',
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 3, md: 4 }} sx={{ width: '100%' }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h6" sx={{ color: '#fff', fontWeight: 800, mb: 1 }}>
            {BRAND_NAME}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2, maxWidth: 320 }}>
            Tecnología, datos y software a medida para empresas que quieren operar mejor
            y crecer con información útil.
          </Typography>
          <Typography variant="caption" sx={{ color: brandColors.gold }}>
            {COMPANY_LOCATION}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="subtitle2" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
            Enlaces
          </Typography>
          <Stack spacing={1}>
            <Link component={RouterLink} to="/" color="inherit" underline="hover">
              Inicio
            </Link>
            <Link href="/#services" color="inherit" underline="hover">
              Servicios
            </Link>
            <Link href="/#contact" color="inherit" underline="hover">
              Contacto
            </Link>
            <Link component={RouterLink} to="/privacidad" color="inherit" underline="hover">
              Política de privacidad
            </Link>
            <Link component={RouterLink} to="/terminos" color="inherit" underline="hover">
              Términos de uso
            </Link>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="subtitle2" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
            Contacto
          </Typography>
          <Stack spacing={1} sx={{ minWidth: 0 }}>
            <Link href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">
              WhatsApp {WHATSAPP_DISPLAY}
            </Link>
            <Link
              href={`mailto:${CONTACT_EMAIL}`}
              color="inherit"
              underline="hover"
              sx={{
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
                display: 'inline-block',
                maxWidth: '100%',
              }}
            >
              {CONTACT_EMAIL}
            </Link>
          </Stack>
        </Grid>
      </Grid>
      <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />
      <Typography variant="body2" align="center" sx={{ color: 'rgba(255,255,255,0.5)' }}>
        © {new Date().getFullYear()} {BRAND_NAME}. Todos los derechos reservados.
      </Typography>
    </Container>
  </Box>
);

export default Footer;
